import { create } from '@thoughtspot/logger';
import { buildCustomVisualProps } from '../../../utils/chart-settings/custom-visual-props';
import { getFlagsFromEventData } from '../native-chart-events/flag-events/utils';
import { validateUpadateVisualPropsEditorEventPayloadObject } from './util';
const logger = create('ts-to-chart > event-callbacks > update-visual-props-editor-definition');
const getUpdateVisualPropsEditorDefinitionEventProcessor = (props) => {
    const { chartModel, currentVisualPropEditorDefinition, updateVisualPropEditorDefinitionContext, persistedVisualPropKey, } = props;
    return {
        validateEventPayload: (eventData) => {
            try {
                validateUpadateVisualPropsEditorEventPayloadObject(eventData.payload?.visualPropEditorDefinition);
            }
            catch (err) {
                logger.warn(err);
                return {
                    isValid: false,
                    errors: [err.toString()],
                };
            }
            return {
                isValid: true,
            };
        },
        executeEvent: async (eventData) => {
            const initFlags = getFlagsFromEventData([
                'isChartSettingsV2Enabled',
            ]);
            const isChartSettingsV2Enabled = initFlags?.isChartSettingsV2Enabled?.flagValue ?? false;
            const updatedVisualPropEditorDefinition = eventData.payload
                ?.visualPropEditorDefinition;
            updateVisualPropEditorDefinitionContext({
                updatedVisualPropEditorDefinition,
                currentVisualPropEditorDefinition,
            });
            const customVisualProps = buildCustomVisualProps({
                isChartSettingsV2Enabled,
                visualPropEditorDefinition: updatedVisualPropEditorDefinition,
                chartModel,
                existingCustomVisualProps: chartModel.customVisualProps,
                persistedVisualPropKeys: persistedVisualPropKey,
            });
            return Promise.resolve(customVisualProps);
        },
    };
};
const testHooks = {
    getUpdateVisualPropsEditorDefinitionEventProcessor,
};
export { testHooks, getUpdateVisualPropsEditorDefinitionEventProcessor };
//# sourceMappingURL=index.js.map